<template>
  <a class="link-button" 
      :class="[ icsType ]"
      :href="targetLink">
    {{ buttonText }}
  </a>
</template>

<script>
export default {
  props: [
    'icsType',
    'targetLink',
    'buttonText',
  ],
};
</script>

<style scoped>
.link-button {
  cursor: pointer;
  text-align: center;
  padding: 2px 10px;
  font-size: 1rem;
  min-width: 64px;
  box-sizing: border-box;
  line-height: 1.5;
  border-radius: 15px;
  letter-spacing: 0.02857em;
  text-decoration: none;
  display: inline-block;
}

.link-button {
  border: 2px solid #000;
  color: #000;
}
.link-button:hover {
  background: #000;
  color: #fff;
}

.link-button.i {
  border: 2px solid #47337C;
  color: #47337C;
}
.link-button.i:hover {
  background: #47337C;
  color: #fff;
}

.link-button.c {  
  border: 2px solid #008cba;
  color: #008cba;
}
.link-button.c:hover {
  background: #008cba;
  color: #fff;
}

.link-button.s {
  border: 2px solid #da4e00;
  color: #da4e00;
}
.link-button.s:hover {
  background: #da4e00;
  color: #fff;
}

@media print {
  .link-button {
    display: none;
  }
}
</style>